import React from 'react'
import injectStyles from 'react-jss'

import { Col, Row } from 'react-bootstrap'
import Form, { Dropzone } from 'Components/Form'

import { styles } from './styles'

const UploadDocumentItem = ({
  typeId,
  classes,
  onUploadDocument,
  onSubmit,
}) => (
  <div>
    <Form
      onSubmit={() =>
        onSubmit({
          typeId,
        })
      }
    >
      <Row xs={9} className={classes.row}>
        <Col xs={3} className={classes.col}>
          <Dropzone
            name="upload-document"
            input={{
              value: '',
              onChange: file => onUploadDocument({ file, typeId }),
            }}
            meta={{}}
            disabled={false}
            accept={'application/pdf, image/*'}
          />
        </Col>
      </Row>
    </Form>
  </div>
)

export default injectStyles(styles)(UploadDocumentItem)
